import { render } from "./TireDamage.vue?vue&type=template&id=13e0a7bf&scoped=true&ts=true"
import script from "./TireDamage.vue?vue&type=script&lang=ts"
export * from "./TireDamage.vue?vue&type=script&lang=ts"

import "./TireDamage.vue?vue&type=style&index=0&id=13e0a7bf&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e0a7bf"]])

export default __exports__